import * as actionTypes from './actionTypes';
import Parse from '../../Parse';

const keys = ["owner","deletedPlanDevice","controller","deviceName","deviceModel","planName","menuVer","appVer","usageMode","clients"];
const limit = 1000;

export const fetchDeviceConfigSuccess = ( deviceConfig ) => {
    return {
        type: actionTypes.FETCH_DEVICE_CONFIG_SUCCESS,
        deviceConfig: deviceConfig
    };
};

export const fetchUserPlanFinish = ( ) => {
    return {
        type: actionTypes.FETCH_USER_PLAN_FINISH
    };
};

export const fetchUserPlanDeviceSuccess = ( userPlanDevice ) => {
    return {
        type: actionTypes.FETCH_USER_PLAN_DEVICE_SUCCESS,
        userPlanDevice: userPlanDevice
    };
};

export const fetchUserPlanSuccess = ( userPlan ) => {
    return {
        type: actionTypes.FETCH_USER_PLAN_SUCCESS,
        userPlan: userPlan
    };
};

export const fetchDeviceConfigStart = (isOwner, owner) => {
    return {
        type: actionTypes.FETCH_DEVICE_CONFIG_START,
        isOwner: isOwner,
        owner: owner
    };
};

export const fetchDeviceConfigFail = () => {
    return {
        type: actionTypes.FETCH_DEVICE_CONFIG_FAIL
    };
};

export const fetchDeviceConfigContinue = (page) => {
    return dispatch => {
        dispatch(fetchDeviceConfigs(page));
    }
};

export const fetchDeviceConfigs = (page, owner, isOwner, token) => {
    return dispatch => {
        if(page === 1) {
            dispatch(fetchDeviceConfigStart(isOwner, owner));
        }
        const skip = (page - 1) * limit;
        const deviceConfig = new Parse.Query('deviceConfig');
        deviceConfig.select(keys);
        if(isOwner === "owner") {
            deviceConfig.equalTo("owner", owner);
        }
        if(isOwner === "notOwner") {
            deviceConfig.notEqualTo("owner", owner);
        }
        deviceConfig.descending("createdAt");
        deviceConfig.skip(skip);
        deviceConfig.limit(limit);
        deviceConfig.find({
            sessionToken: token
        }).then((results) => {
            if(results.length <= 0) {
                dispatch(fetchDeviceConfigFinish(1));
                return;
            }
            dispatch(fetchDeviceConfigSuccess(results));
            if(results.length < limit - 1) {
                dispatch(fetchDeviceConfigFinish(1, owner, isOwner, token));
            }
            else {
                page++;
                dispatch(fetchDeviceConfigs(page, owner, isOwner, token));
            }
        })
        .catch(error => {
            dispatch(fetchDeviceConfigFail(error));
        });
    };
};

export const fetchDeviceConfigFinish = (page, owner, isOwner, token) => {
    return dispatch => {
        const skip = (page - 1) * limit;
        const userPlanDevice = new Parse.Query('userPlanDevice');
        if(isOwner === "owner") {
            userPlanDevice.equalTo("owner", owner);
        }
        if(isOwner === "notOwner") {
            userPlanDevice.notEqualTo("owner", owner);
        }
	    userPlanDevice.descending("createdAt");
        userPlanDevice.skip(skip);
        userPlanDevice.limit(limit);
        userPlanDevice.find({
            sessionToken: token
        }).then((results) => {
            if(results.length <= 0) {
                dispatch(fetchUserPlanDeviceFinish(1, owner, token));
                return;
            }
            dispatch(fetchUserPlanDeviceSuccess(results));
            if(results.length < limit - 1) {
                dispatch(fetchUserPlanDeviceFinish(1, owner, token));
            }
            else {
                page++;
                dispatch(fetchDeviceConfigFinish(page, owner, isOwner, token));
            }
        })
        .catch(error => {
            dispatch(fetchDeviceConfigFail(error));
        });
    };
};

export const fetchUserPlanDeviceFinish = (page, owner, token) => {
    return dispatch => {
        const skip = (page - 1) * limit;
        const oldUserPlan = Parse.Object.extend('userPlan');			
        const oldQuery = new Parse.Query(oldUserPlan);			
        oldQuery.descending("createdAt");
        oldQuery.skip(skip);
        oldQuery.limit(limit);
        oldQuery.find({
            sessionToken: token
        }).then((results) => {
            if(results.length <= 0) {
                dispatch(fetchUserPlanFinish());
                return;
            }
            dispatch(fetchUserPlanSuccess(results));
            if(results.length < limit - 1) {
                dispatch(fetchUserPlanFinish());
            }
            else {
                page++;
                dispatch(fetchUserPlanDeviceFinish(page, owner, token));
            }
        })
        .catch(error => {
            dispatch(fetchDeviceConfigFail(error));
        });
    };
};

export const addControllerStationIds = (controllerIds) => {
    return {
        type: actionTypes.ADD_CONTROLLER_STATION_IDS,
        controllerIds: controllerIds
    };
};

export const removeOutlets = () => {
    return {
        type: actionTypes.FETCH_OUTLET_REFRESH
    };
}